export const SQL_KEYWORDS = [
    'Account',
    'All',
    'Alter',
    'And',
    'Any',
    'As',
    'Asc',
    'Bernoulli',
    'Between',
    'Binary',
    'Block',
    'Boolean',
    'By',
    'Case',
    'Cast',
    'Char',
    'Character',
    'Check',
    'Column',
    'Connect',
    'Connect_by_root',
    'Connection',
    'Constraint',
    'Create',
    'Cross',
    'Cube',
    'Current',
    'Current_date',
    'Current_time',
    'Current_timestamp',
    'Current_user',
    'Database',
    'Datetime',
    'Day',
    'Dec',
    'Decimal',
    'Delete',
    'Desc',
    'Distinct',
    'Drop',
    'Else',
    'End',
    'Escape',
    'Except',
    'Exists',
    'False',
    'Fetch',
    'First',
    'Following',
    'For',
    'From',
    'Full',
    'Grant',
    'Group',
    'Grouping',
    'Gscluster',
    'Having',
    'Hour',
    'Ilike',
    'In',
    'Increment',
    'Inner',
    'Insert',
    'Intersect',
    'Into',
    'Is',
    'Issue',
    'Join',
    'Last',
    'Lateral',
    'Left',
    'Like',
    'Limit',
    'Local',
    'Localtime',
    'Localtimestamp',
    'Minus',
    'Minute',
    'Month',
    'Natural',
    'Next',
    'Not',
    'Null',
    'Nulls',
    'Number',
    'Numeric',
    'Obj',
    'Of',
    'Offset',
    'On',
    'Only',
    'Or',
    'Order',
    'Organization',
    'Outer',
    'Over',
    'Partition',
    'Preceding',
    'Precision',
    'Qualify',
    'Range',
    'Recursive',
    'Regexp',
    'Repeatable',
    'Revoke',
    'Right',
    'Rlike',
    'Rollup',
    'Row',
    'Rows',
    'Sample',
    'Schema',
    'Second',
    'Seed',
    'Select',
    'Semi',
    'Set',
    'Sets',
    'Some',
    'Start',
    'String',
    'System',
    'Table',
    'Tablesample',
    'Template',
    'Text',
    'Then',
    'Timestamp',
    'Timestamp_ltz',
    'Timestamp_ntz',
    'Timestamp_tz',
    'Timestampltz',
    'Timestampntz',
    'Timestamptz',
    'To',
    'Top',
    'Trigger',
    'True',
    'Try_cast',
    'Type',
    'Unbounded',
    'Union',
    'Unique',
    'Update',
    'Using',
    'Values',
    'Varbinary',
    'Varchar',
    'Varying',
    'View',
    'When',
    'Whenever',
    'Where',
    'With',
    'Without',
    'Year',
    'Zone'
];

export const FORMULA_KEYWORDS = [
    'And',
    'As',
    'Between',
    'Binary',
    'Boolean',
    'By',
    'Case',
    'Cast',
    'Char',
    'Character',
    'Current_date',
    'Current_time',
    'Current_timestamp',
    'Current_user',
    'Datetime',
    'Decimal',
    'Else',
    'End',
    'Exists',
    'Ilike',
    'In',
    'Is',
    'Like',
    'Localtime',
    'Localtimestamp',
    'Natural',
    'Not',
    'Null',
    'Number',
    'Numeric',
    'Minus',
    'Or',
    'Regexp',
    'Rlike',
    'Semi',
    'String',
    'Text',
    'Then',
    'Timestamp',
    'Timestamp_ltz',
    'Timestamp_ntz',
    'Timestamp_tz',
    'Timestampltz',
    'Timestampntz',
    'Timestamptz',
    'True',
    'Varbinary',
    'Varchar',
    'When'
];

export const ALL_KEYWORDS = SQL_KEYWORDS.concat(FORMULA_KEYWORDS).map((v) => v.toLowerCase());
